import React from "react";
import { useAuth } from "../contexts/AuthContext";
import logo from "../assets/logo.svg";
import "./Sidebar.css";

/**
 * Navigation sidebar with tab links and user info.
 */
function Sidebar({ activeTab, onTabChange, isOpen }) {
  const { user, logout } = useAuth();

  return (
    <aside className={`sidebar ${isOpen ? "sidebar--open" : ""}`}>
      {/* Brand */}
      <div className="sidebar-brand">
        <img src={logo} alt="Insuraviews" className="sidebar-brand-logo" />
        <span className="sidebar-brand-text">Insuraviews</span>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        <button
          className={`sidebar-nav-item ${
            activeTab === "analytics" ? "sidebar-nav-item--active" : ""
          }`}
          onClick={() => onTabChange("analytics")}
        >
          <svg
            width="20"
            height="20"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <rect x="3" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="3" width="7" height="7" rx="1" />
            <rect x="3" y="14" width="7" height="7" rx="1" />
            <rect x="14" y="14" width="7" height="7" rx="1" />
          </svg>
          <span>Analytics</span>
        </button>

        <button
          className={`sidebar-nav-item ${
            activeTab === "users" ? "sidebar-nav-item--active" : ""
          }`}
          onClick={() => onTabChange("users")}
        >
          <svg
            width="20"
            height="20"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
          <span>User Management</span>
        </button>
      </nav>

      {/* User info & logout */}
      <div className="sidebar-footer">
        <div className="sidebar-user">
          {user?.picture ? (
            <img
              className="sidebar-user-avatar"
              src={user.picture}
              alt={user.name}
              referrerPolicy="no-referrer"
            />
          ) : (
            <div className="sidebar-user-avatar sidebar-user-avatar--placeholder">
              {user?.name?.charAt(0) || "A"}
            </div>
          )}
          <div className="sidebar-user-info">
            <span className="sidebar-user-name">{user?.name}</span>
            <span className="sidebar-user-email">{user?.email}</span>
          </div>
        </div>
        <button className="sidebar-logout" onClick={logout} title="Sign out">
          <svg
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
